import React from 'react';
import classNames from 'classnames';
import ReactDropzone from 'react-dropzone';
import { Field } from 'redux-form';

import { onClickWrapper } from '../../../utils/ui';

import styles from './index.module.scss';

class Dropzone extends React.Component {
  static renderDropzone = ({
    className,
    id,
    children,
    onDrop,
    accept,
    noClick,
    noDrag,
    multiple,
    maxSize,
    maxFileCount,
    multipleAdding,
    onMaxSizeExcess,
    input,
  }) => (
    <ReactDropzone
      onDrop={(files) => {
        if (multipleAdding && input.value) {
          const temp = [...input.value];
          files = temp.push(...files);
          files = temp;
        }
        if (maxFileCount && files.length > maxFileCount) {
          files = files.slice(0, maxFileCount);
        }
        if (maxSize) {
          const excessed = files.filter((file) => file.size > maxSize);
          if (excessed.length && onMaxSizeExcess) {
            onMaxSizeExcess(excessed.map((file) => file.name));
          }
          files = files.filter((file) => file.size <= maxSize);
        }
        (input ? input.onChange : onDrop ? onDrop : () => {})(files);
      }}
      value={(input && input.value) || undefined}
      {...{ noClick, noDrag, multiple, accept }}
    >
      {({ getRootProps, getInputProps }) => {
        const rootProps = getRootProps({
          tabIndex: undefined,
        });
        return (
          <div
            {...rootProps}
            onClick={onClickWrapper(id, rootProps.onClick)}
            className={classNames(
              noClick ? '' : styles['dropzone__click'],
              className
            )}
            id={id}
          >
            <input {...getInputProps()} />
            {children}
          </div>
        );
      }}
    </ReactDropzone>
  );

  render() {
    const {
      name,
      validate,
      children,
      className,
      id,
      noClick,
      noDrag,
      accept,
      multiple,
      maxSize,
      maxFileCount,
      multipleAdding,
      onMaxSizeExcess,
    } = this.props;

    const customProps = {
      children,
      className,
      id,
      noClick,
      noDrag,
      accept,
      multiple,
      maxSize,
      maxFileCount,
      multipleAdding,
      onMaxSizeExcess,
    };

    return name ? (
      <Field
        component={Dropzone.renderDropzone}
        name={name}
        props={customProps}
        validate={validate}
      />
    ) : (
      Dropzone.renderDropzone(customProps)
    );
  }
}

export default Dropzone;
